import { render, staticRenderFns } from "./video-collection.vue?vue&type=template&id=63d3e7f2&scoped=true"
import script from "./video-collection.vue?vue&type=script&lang=js"
export * from "./video-collection.vue?vue&type=script&lang=js"
import style0 from "./video-collection.vue?vue&type=style&index=0&id=63d3e7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3e7f2",
  null
  
)

export default component.exports